export const LOCATION_TO_PAGING: Record<string, { valid: RegExp }> = {
  "shipping-list": {
    valid: /^\/?(?:offers\/\d+\/shipping-case\/\d+(?:\/.*)?|shippings)$/,
  },
  "offer-list": {
    valid: /^\/?offers(?:\/.*)?$/,
  },
  "lite-tms": {
    valid: /^\/?(?:tms|offers\/\d+\/shipping-case\/\d+\/tms(?:\/.*)?)?$/,
  },
};
